import React, { useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import {
  useFlowData,
  getFlowDataDirect,
  setFlowDataDirect,
  subscribeDataChange,
  unsubscribeDataChange,
  formatString,
  StringFormats,
  useFlowController,
  PopupTip,
  timeout,
  handleSendKlaviyoEvents,
  updateQuoteNumberToPets,
} from "@adaptis/flow-components";
import Loader from "../Loader";
import LoadingLightbox from "../LoadingLightbox";
import PetsyCanvasConfetti from "../PetsyCanvasConfetti";
import PetsyHighestLevelPopup from "../PetsyHighestLevelPopup";
import {
  getPaymentFrequencyLabel,
  setQuoteData,
  logQuote,
  setPetOriginalModel,
  getPetOriginalModel,
  getOriginalPostCode,
  setOriginalPostCode,
} from "../../util/data-store";
import _ from "../../imports/lodash-imports";
import { getQuote } from "../../util/knose-api-wrapper";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { AnimatePresence, motion } from "framer-motion";
import {
  klaviyoTrack,
  pushDataToGTM,
  getPetAge,
  callApiSaveQuote,
  callApiGetAlternateQuotes,
} from "../../KnoseAPI/Lib/Utils";
import { Modal, ModalProps, Button, Image } from "react-bootstrap";
import { tips } from "../PopupTips/tips";
import Config from "../../app-config";
import { logEvent } from "@adaptis/flow-components";
import { ISelectedCoverProps } from "./SelectedCover.types";
import "./SelectedCover.scss";
import {
  calculatePriceFromPaymentFrequency,
  getGTMQuoteData,
  getAFXProfile,
} from "../../util/helper-functions";
import { useLocation } from "react-router-dom";
import PetsyQuoteNumber from "../PetsyQuoteNumber";
import { ReactSVGWrapper } from "../WrapperComponent";

export default function SelectedCover(props: ISelectedCoverProps) {
  let title = props.title;
  let stickyTitle = props.stickyTitle;
  let description = props.description;
  let lowerDescription = props.lowerDescription;
  let lastLine = props.lastLine;
  let myRef = React.useRef<any>();
  let refConfetti = React.useRef<any>();
  let isGettingPriceRef = React.useRef(false);

  const { getData, setData, injectData } = useFlowData();
  const location = useLocation();
  const [qouteNumber, setQuoteNumber] = useState("");
  const [hasInitialOptions, setHasInitialOptions] = useState(false);
  const [isShowHighestLevelPopup, setIsShowHighestLevelPopup] = useState(false);
  const [isShowConfetti, setIsShowConfetti] = useState(false);
  const [countRunEffect, setCountRunEffect] = useState(0);
  const [countCheckConfetti, setCountCheckConfetti] = useState(0);
  const [isMultiPetPromoCode, setIsMultiPetPromoCode] = useState<boolean>(false);
  const [coverType, setCoverType] = useState("");
  const [petType, setPetType] = useState("");
  const { getDataFromArray } = useFlowData();

  if (props.step) {
    title = injectData(props.title);
    stickyTitle = injectData(props.stickyTitle);
    description = injectData(props.description);
    lowerDescription = injectData(props.lowerDescription ?? "");
    lastLine = injectData(props.lastLine ?? "");
  }

  const petAgeCategory = getData("petAgeCategory");
  const paymentFrequencyDataField = props.dataField + ".paymentFrequency";
  const initialPaymentFrequency = getData(paymentFrequencyDataField);
  let setDefaultPaymentFrequency = initialPaymentFrequency ? false : true;
  const [paymentFrequency, setPaymentFrequency] = React.useState(
    initialPaymentFrequency ?? "monthly"
  );

  let currentWasPrice = 0;
  let currentNowPrice = 0; //990; // TEMP set to 0 for prod

  const [price, setPrice] = React.useState({
    isSet: false,
    was: currentWasPrice,
    now: currentNowPrice,
  });

  const [loadingPrice, setLoadingPrice] = React.useState(false);
  const [showPriceSticky, setShowPriceSticky] = React.useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);

  useScrollPosition(
    ({ currPos }) => {
      const hide = currPos.y >= 500;
      if (hide !== showPriceSticky) setShowPriceSticky(hide);
    },
    [showPriceSticky],
    undefined,
    true,
    150
  );

  function handleDataChange(dataPath: string, dataField: string, data: any) {
    const fieldsToTrack = [
      "customCover.benefitPercentage",
      "customCover.annualBenefitLimit",
      "customCover.annualExcess",
      "customCover.optionalExtras",
      "customCover.vetConsultationFees",
      // "promoCode",
    ];
    if (fieldsToTrack.includes(dataField)) {
      let checkAnnualLimit = false;
      let checkAnnualLimitNormal = false;

      if (
        (dataField === "customCover.annualBenefitLimit" ||
          dataField === "customCover.annualExcess" ||
          dataField === "customCover.optionalExtras" ||
          dataField === "customCover.vetConsultationFees") &&
        getData("customCover.annualExcess") == 0 &&
        getData("customCover.annualBenefitLimit") == 25000 &&
        getData("customCover.optionalExtras") === "yes" &&
        getData("customCover.vetConsultationFees") === "yes"
      ) {
        checkAnnualLimitNormal = true;
      }
      if (petAgeCategory && checkAnnualLimitNormal) {
        checkAnnualLimit = true;
      }
      const currentCoverType = getData("coverType");
      getPrice(checkAnnualLimitNormal, currentCoverType);
    }
  }

  React.useEffect(() => {
    let quoteNo = getData("root.mmSessionId") ?? "";
    // let quoteNo = getData("root.quoteNo") ?? "";
    if (quoteNo) {
      setQuoteNumber(quoteNo);
    }
  });
  React.useEffect(() => {
    let coverTypeFromData = "";
    if (props.step) {
      coverTypeFromData = getData("coverType");
      setCoverType(coverTypeFromData);
    }
    setPetType(getData("petType"));
    // Anything in here is fired on component mount.
    if (petAgeCategory) {
      setIsShowConfetti(true);
    }
    let customCover = getData("customCover");
    if (customCover && customCover.premiums) {
      setPrice({
        isSet: true,
        was: customCover.premiums.installment_before_discount ?? 0,
        now: customCover.premiums.installment,
      });
    }
    subscribeDataChange("SelectedCover", handleDataChange);
    if (setDefaultPaymentFrequency) setData(paymentFrequencyDataField, "monthly");

    // Only get price if no quote exists
    // This code requires monitoring of datastore outside of this component
    // to work properly.  Commenting out for now.
    let quoteNumber = getData(coverTypeFromData + "Cover.quoteNumber");
    let oldquoteNumber = getData(coverTypeFromData + "Cover.oldQuote");
    let needUpdateQuote = getData("needUpdateQuote");
    if (
      (!quoteNumber && oldquoteNumber) ||
      (quoteNumber && !customCover.premiums) ||
      needUpdateQuote
    ) {
      // console.log("PPP-161 getPrice-1");
      getPrice(false, coverTypeFromData);
    }

    if (!getData("customCover.annualBenefitLimit")) {
      setDefaultOptions();
    }

    checkIfModelHasBeenChanged();

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange("SelectedCover");
    };
  }, []);

  function setDefaultOptions() {
    // const multiPetPromoCode = getFlowDataDirect("multiPetPromoCode");
    if (!getData("coverType")) setData("coverType", "custom");
    // let pets = getData("root.pets");
    // let validPets = pets.filter((pet: any) => pet.customCover);
    // const promoCode = getData("customCover.promoCode");
    // let firstPet = validPets.findIndex((pet: any) => !pet.customCover.promoCode);
    // if (validPets && pets.length > 1 && validPets.length > 1 && firstPet >= 0 && !promoCode) {
    //   setData("customCover.promoCode", multiPetPromoCode);
    // }

    if (!getData("customCover.annualBenefitLimit"))
      setData("customCover.annualBenefitLimit", "10000");

    if (!getData("customCover.benefitPercentage")) setData("customCover.benefitPercentage", "80");

    if (!getData("customCover.annualExcess")) setData("customCover.annualExcess", "200");

    if (!getData("customCover.optionalExtras")) setData("customCover.optionalExtras", "no");

    if (!getData("customCover.vetConsultationFees")) {
      setData("customCover.vetConsultationFees", "yes");
      // if (petAgeCategory && petAgeCategory <= 4) {
      //   setData("customCover.vetConsultationFees", "yes");
      // } else {
      //   setData("customCover.vetConsultationFees", "no");
      // }
    }

    let quoteNo = getData("root.mmSessionId") ?? "";
    if (quoteNo != "") {
      setQuoteNumber(quoteNo);
      setData("root.quoteNo", quoteNo);
      // setLoadingPrice(false);
      setPrice({
        isSet: true,
        was: getData("customCover.totalInstallmentBeforeDiscount") ?? 0,
        now: getData("customCover.installmentAmount") ?? 0,
      });
    }
  }

  function checkIfModelHasBeenChanged() {
    let isSavedQuote = getFlowDataDirect("isSavedQuote");
    let isChangedData = getFlowDataDirect("isChangedData");
    let quoteNo = getData("root.quoteNo") ?? "";
    let petsCurrent = getData("root.pets");

    let currentPostCode = getFlowDataDirect("holderAddress.postcode");
    let originalPostCode = getOriginalPostCode();

    if (quoteNo != "") {
      let returnIsEqual = false;

      let petsOriginal = getPetOriginalModel();
      let isEqualPets = _.isEqual(petsCurrent, petsOriginal);

      let isEqualPostCode = _.isEqual(currentPostCode, originalPostCode);
      if (!isChangedData && (isSavedQuote || (isEqualPets && isEqualPostCode)))
        returnIsEqual = true;

      if (!returnIsEqual) {
        const currentCoverType = getData("coverType");
        getPrice(false, currentCoverType);
      } else if (petAgeCategory) {
        RunShowConfetti();
      }
    }
  }

  function RunShowConfetti() {
    setTimeout(() => {
      setIsShowConfetti(false);
      setCountRunEffect((current) => current + 1);
    }, 1000);
  }

  async function getPrice(showConfetti?: boolean, coverTypeParam?: string) {
    setData("needUpdateQuote", false);
    setData("root.isInvalidPromotionCode", false);
    setFlowDataDirect("isSavedQuote", false);
    setFlowDataDirect("isChangedData", false);
    if (coverTypeParam === "top") {
      setData("topCover.benefitPercentage", 90);
      setData("topCover.annualBenefitLimit", 25000);
      setData("topCover.annualExcess", 0);
      setData("topCover.optionalExtras", "yes");
    } else if (coverTypeParam === "custom") {
      const customCoverOptions = getData(props.dataField ?? "");
      if (!customCoverOptions?.benefitPercentage) return;
      if (!customCoverOptions?.annualBenefitLimit) return;
      if (!customCoverOptions?.annualExcess) return;
      if (!customCoverOptions?.optionalExtras) return;
      if (!customCoverOptions?.vetConsultationFees) return;
    }
    if (isGettingPriceRef.current) {
      console.log("[SelectedCover] getPrice is already running, skipping...");
      return;
    }
    isGettingPriceRef.current = true;
    setLoadingPrice(true);
    if (getFlowDataDirect("promoCode")) {
      setData(coverTypeParam + "Cover.promoCode", getFlowDataDirect("promoCode"));
    }

    setData(coverTypeParam + "Cover.hasQuote", false);

    // Get quote from Knose API
    const petNo = getData("pet_no");
    const petId = getData("id");
    let petData = getDataFromArray("pets", "id", petId);
    let petDataClone = _.cloneDeep(petData);
    const allPetsRaw = getData("root.pets");
    let allPets = Array.isArray(allPetsRaw) ? allPetsRaw : [];
    let promoCode = getFlowDataDirect("promoCode");
    let multiPetPromoCode: string = getFlowDataDirect("multiPetPromoCode");
    let isMultiPet = petData?.customCover?.promoCode === multiPetPromoCode;
    setIsMultiPetPromoCode(isMultiPet);

    let isQuotePrice = false;
    let currentPremiums: any, currentPromo: any;
    allPets.forEach((pet: any, petIndex: Number) => {
      const quotes = pet?.quotes || [];
      const annualBenefitLimitCover = Number(pet?.customCover?.annualBenefitLimit);
      const annualExcessCover = Number(pet?.customCover?.annualExcess);
      const benefitPercentageCover = Number(pet?.customCover?.benefitPercentage);
      const optionalExtras = pet?.customCover?.optionalExtras === "yes";
      const vetConsultationFees = pet?.customCover?.vetConsultationFees === "yes";
      //   console.log("[Debug] optionalExtras: ", optionalExtras);
      //   console.log("[Debug] vetConsultationFees: ", vetConsultationFees);
      quotes.map((quote: any) => {
        const annualBenefitLimit = quote?.benefits?.benefitLimits?.annualBenefitLimit;
        const excess = quote?.benefits?.benefitLimits?.excess;
        const benefitPercentage = quote?.benefits?.benefitLimits?.benefitPercentage;
        const behaviouralTreatmentCover = quote?.benefits?.extrasCover?.behaviouralTreatmentCover;
        if (
          annualBenefitLimit === annualBenefitLimitCover &&
          excess === annualExcessCover &&
          benefitPercentage === benefitPercentageCover &&
          optionalExtras === behaviouralTreatmentCover &&
          vetConsultationFees
        ) {
          //   console.log("PPP-274 annualBenefitLimit: ", annualBenefitLimit);
          //   console.log("PPP-274 excess: ", excess);
          //   console.log("PPP-274 benefitPercentage: ", benefitPercentage);
          //   console.log("PPP-274 behaviouralTreatmentCover: ", behaviouralTreatmentCover);

          const premiums = {
            installment: quote?.premium?.monthlyPremium,
            installment_before_discount: quote?.premium?.monthlyPremium,
            premium: 0,
            stamp_duty: 0,
            installmentStampDuty: 0,
            policy_fee: 0,
            principal_amount: quote?.premium?.monthlyPremium,
            totalPayable: quote?.premium?.annualPremium,
            totalPayableBeforeDiscount: quote?.premium?.annualPremium,
            premiumGST: 0,
            prePaymentPeriodMonths: 1,
          };
          currentPremiums = premiums;
          setData(`pets[${petIndex}]["${coverTypeParam}Cover"].premiums`, premiums);
          setData(`pets[${petIndex}].isQuotePrice`, true);
          if (petIndex == petNo) {
            isQuotePrice = true;
          }
        }
      });
    });

    if (isQuotePrice) {
      isGettingPriceRef.current = false;
      setPrice({
        isSet: true,
        was: currentPremiums?.installment_before_discount ?? 0,
        now: currentPremiums?.installment ?? 0,
      });
    } else {
      let quote;
      const timeoutError = Symbol();
      try {
        const result = await timeout(getQuote(allPets), Config.websevice_timeout, timeoutError);

        setCountCheckConfetti((current) => current + 1);
        if (!result || !result.data || result.data.process != result.data.total) {
          const { errMsg } = result?.data ?? null;
          if (errMsg) {
            let isPromocodeInvalid = errMsg.find((item: any) =>
              item.includes("Promo code invalid")
            );
            setData("root.isInvalidPromotionCode", isPromocodeInvalid ? true : false);
          }
          throw ["Error quote result is invalid", result];
        }
        quote = result.data.quote;
      } catch (e: any) {
        setCountCheckConfetti((current) => current + 1);
        if (e === timeoutError) {
          // handle timeout
          console.log("getPrice() Timeout");
          setLoadingPrice(false);
          setShowErrorModal(true);
          logEvent("error-timeout", true, "getPrice() Timeout = " + Config.websevice_timeout);
          return;
        } else {
          // other error
          console.log("getPrice() Error", e);
          // throw e;
          setLoadingPrice(false);
          setShowErrorModal(true);
          logEvent("error", true, "SelectedCover->getPrice()", e);
          return;
        }
      } finally {
        isGettingPriceRef.current = false;
      }
      let currentPremiums: any, currentPromo: any;
      if (!quote) return;
      quote.pets.forEach((pet: any) => {
        let { premiums, promo } = pet;
        let petIndex = allPets.findIndex((p: any) => p.pet_no == pet.pet_no);
        if (petIndex >= 0) {
          setData(`pets[${petIndex}]["${coverTypeParam}Cover"].premiums`, pet.premiums);
          setData(`pets[${petIndex}].isQuotePrice`, false);
          setData(
            `pets[${petIndex}]["${coverTypeParam}Cover"].promo`,
            pet.promo ? pet.promo : null
          );
        }

        if (pet.pet_no == petNo) {
          currentPremiums = premiums;
          currentPromo = promo;
        }
        if (promoCode && promo) {
          setData("root.promoCodeType", parseInt(promo.promoType.replace("Type", "")));
        }
      });

      if (!currentPremiums) {
        const idx = allPets.findIndex((p: any) => p.pet_no == petNo);
        if (idx >= 0) {
          currentPremiums = getData(`pets[${idx}]["${coverTypeParam}Cover"].premiums`);
        }
      }

      setPrice({
        isSet: true,
        was: currentPremiums?.installment_before_discount ?? 0,
        now: currentPremiums?.installment ?? 0,
      });
    }

    setData(coverTypeParam + "Cover.hasQuote", true);

    let paymentFrequencyValue = getData("root.selectedPaymentFrequency");
    if (!paymentFrequencyValue) setData("root.selectedPaymentFrequency", "Fortnightly");
    else setData("root.selectedPaymentFrequency", paymentFrequencyValue);

    let quoteNo = getData("root.mmSessionId") ?? "";

    if (quoteNo != "") {
      setQuoteNumber(quoteNo);
      setData("root.quoteNo", quoteNo);

      let pets = getData("root.pets");
      let clonedPets = _.cloneDeep(pets);
      setPetOriginalModel(clonedPets);

      let originalPostCode = getFlowDataDirect("holderAddress.postcode");
      setOriginalPostCode(originalPostCode);

      setData("root.quote-slug", "/custom-cover/" + (location.pathname.split("/")[2] || ""));
    }

    if (showConfetti) {
      setCountRunEffect((current) => current + 1);
      setIsShowHighestLevelPopup(true);
    }

    // Update petAnnualLimit
    let petAnnualLimit = parseInt(petDataClone.customCover.annualBenefitLimit);
    if (petAgeCategory && petAgeCategory < 3) {
      petAnnualLimit = petAnnualLimit + petAnnualLimit * 0.2;
    } else if (petAgeCategory && petAgeCategory >= 3) {
      petAnnualLimit = petAnnualLimit + petAnnualLimit * 0.1;
    }
    petDataClone.customCover.annualBenefitLimit = petAnnualLimit.toString();
    // pushDataToGTM(
    //   "Custom_Cover_Details",
    //   getGTMQuoteData("Custom_Cover_Details", { petData: petDataClone })
    // );

    //Save quote
    // Prepare quote payload
    const sessionId = getData("root.sessionId") ?? "";
    const quoteNumber = getData("root.petsyQuoteNumber") ?? "";
    const parentQuoteNumber = getData("root.parentQuoteNumber") ?? "";
    const landingPage = getData("root.landingPage") ?? "";
    const holderEmail = getData("root.holderEmail") ?? "";
    let adfixusID = getAFXProfile();
    if (adfixusID === "(not set)") {
      adfixusID = "";
    }

    let pets = getData("root.pets") ?? [];

    //Loại bỏ pet khong có customCover
    pets = pets.filter((pet: any) => pet.customCover);

    let petsDataPayload = await Promise.all(
      pets.map(async (pet: any) => {
        //Ktra pet nào chưa có alternateQuotes thì sẽ call api để lấy
        if (!pet.alternateQuotes) {
          let startDate = pet?.startDate ?? "";
          let petDetails = {
            petName: pet?.name ?? "",
            type: pet?.petType ? pet.petType.toUpperCase() : "",
            breed: pet?.breed ?? "",
            dateOfBirth: pet?.petDOB ?? "",
            petGender: pet?.petSex ? pet.petSex.toUpperCase() : "",
            address: {
              state: getData("root.holderAddress.state") ?? "",
              suburb: getData("root.holderAddress.suburb") ?? "",
              postcode: getData("root.holderAddress.postcode") ?? "",
            },
          };
          const minPriceConfigs = {
            minimumBenefitPercentage: 80,
            minimumAnnualBenefit: 5000,
            maximumExcess: 500,
            startDate,
            requiredExtras: {
              behaviouralTreatmentCover: false,
              routineCareCover: false,
              dentalCover: false,
            },
          };
          const maxPriceConfigs = {
            minimumBenefitPercentage: 80,
            minimumAnnualBenefit: 10000,
            maximumExcess: 150,
            startDate,
            requiredExtras: {
              behaviouralTreatmentCover: pet?.petAgeOnStartDatePolicy > 1094 ? false : true,
              routineCareCover: false,
              dentalCover: false,
            },
          };
          const fetchedAlternateQuotes = await callApiGetAlternateQuotes(
            quoteNumber,
            petDetails,
            minPriceConfigs,
            maxPriceConfigs,
            petAgeCategory
          );
          pet.alternateQuotes = fetchedAlternateQuotes;
        }

        return {
          email: holderEmail,
          Session_id: sessionId,
          id: pet ? pet.id : "",
          petType: pet ? pet.petType : "",
          petTypeIndex: pet ? pet.petTypeIndex : "",
          petOrdinalName: pet ? pet.petOrdinalName : "",
          petShowedPopup: pet ? pet.isShowedPopup : "",
          name: pet ? pet.name : "",
          isValid: pet ? pet.isValid : "",
          isTouched: pet ? pet.isTouched : "",
          breed: pet ? pet.breed : "",
          petDOB: pet ? pet.petDOB : "",
          petAgeOnStartDatePolicy: pet ? pet.petAgeOnStartDatePolicy : "",
          petSex: pet ? pet.petSex : "",
          isDesexed: pet ? pet.isDesexed : "",
          startDate: pet ? pet.startDate : "",
          customCover: pet ? pet.customCover : "",
          alternateQuotes: pet.alternateQuotes ?? "",
          coverType: pet ? pet.coverType : "",
          petAgeCategory: pet ? pet.petAgeCategory : "0",
          quoteNumber: pet ? pet.customCover.quoteNumber : null,
          parentQuoteNumber: parentQuoteNumber ?? null,
          channel: "FiftyupQT",
          Adfixus_ID: adfixusID,
          landingPage,
        };
      })
    );
    // console.log("PPP-274 Pets: ",pets);
    const quotePayload = {
      sessionId: sessionId,
      quoteNumber: quoteNumber,
      parentQuoteNumber: parentQuoteNumber,
      pets: petsDataPayload,
      profile: {
        Holder_Email: holderEmail,
        Holder_First_Name: getData("root.holderFirstName") ?? "",
        Holder_Last_Name: getData("root.holderLastName") ?? "",
        Holder_DOB: getData("root.holderDOB") ?? "",
        Holder_Phone: getData("root.holderPhone") ?? "",
        Holder_Post_Code: getData("root.holderAddress.postcode") ?? "",
        Holder_State: getData("root.holderAddress.state") ?? "",
        Holder_Suburb: getData("root.holderAddress.suburb") ?? "",
        Holder_Address_Line_1: getData("root.holderAddress.line1") ?? "",
        Holder_Address_Line_2: getData("root.holderAddress.line2") ?? "",
        Session_id: sessionId,
        channel: "FiftyupQT",
      },
    };
    // Call save-quote API
    let quoteSaveData = await callApiSaveQuote(quotePayload);
    if (quoteSaveData && quoteSaveData.success && quoteSaveData.data) {
      await updateQuoteNumberToPets(quoteSaveData);
      setData("root.quoteNumber", quoteSaveData.data.quoteNumber);
    }
    await handleSendKlaviyoEvents("Custom_Cover_Details", [petData]);
    setLoadingPrice(false);
  }

  function ErrorModal(props: ModalProps) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Quote Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Something went wrong while getting your quote. There may be a problem connecting to the
            Internet.
          </p>
          <p>
            Click the Retry button below to try again or you can call us on{" "}
            <b>
              <a href="tel:1300 952 790">1300 952 790</a>
            </b>{" "}
            or email us at{" "}
            <b>
              <a href="mailto:hello@petsy.com.au">hello@petsy.com.au</a>
            </b>
            .
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              setShowErrorModal(false);
              logEvent("error-retry", true, "Quote retry click");
              getPrice(false, "custom");
            }}
          >
            Retry
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function formatDate(dateString: string) {
    if (!dateString) return "";

    let date = new Date(dateString);
    let month = new Intl.DateTimeFormat("en-AU", { month: "short" }).format(date);
    return `${date.getDate()} ${month} ${date.getFullYear()}`;
  }

  const flowController = useFlowController();

  function PetDescription() {
    let ownerFirstName = getFlowDataDirect("holderFirstName");
    let petName: string = getData("name");
    let breed: string = getData("breed");
    let sex: string = getData("petSex");
    let sexDescriptor = sex === "male" ? "handsome" : "cute";
    let isDesexed: string = getData("isDesexed");
    let isDesexedDesc: string = isDesexed == "Yes" ? "" : "not ";
    let petDob: string = getData("petDOB");
    let petDobFormatted: string = formatDate(petDob);
    let startDate: string = getData("startDate");
    let startDateFormatted: string = formatDate(startDate);
    let suburb: string = getFlowDataDirect("holderAddress.suburb");
    let state: string = getFlowDataDirect("holderAddress.state");

    function handleLinkClick(e: any, item: string) {
      e.preventDefault();
      if (getFlowDataDirect("TransferQuoteCallBack") === "Yes") {
        return "#";
      }

      switch (item) {
        case "ownerFirstName":
        case "suburbState":
          flowController.gotoStep("/step-1");
          break;
        case "petName":
        case "breed":
          flowController.gotoStep("/edit-cover-1");
          break;
        case "sex":
        case "petDob":
        case "isDesexed":
          flowController.gotoStep("/edit-cover-2");
          break;
        case "startDate":
          flowController.gotoStep("/edit-cover-3");
          break;
        default:
          alert(item + " link clicked");
      }
    }

    return (
      <div className="pet-description">
        A ridiculously {sexDescriptor}{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "breed")}>
          {breed}
        </a>{" "}
        named{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "petName")}>
          {petName}
        </a>{" "}
        living with{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "ownerFirstName")}>
          {ownerFirstName}
        </a>{" "}
        in{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "suburbState")}>
          {suburb}, {state}
        </a>
        . {petName} is{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "sex")}>
          {sex}
        </a>
        , born on{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "petDob")}>
          {petDobFormatted}
        </a>{" "}
        and{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "isDesexed")}>
          is {isDesexedDesc}desexed
        </a>
        . {petName}'s policy will start at 11.59pm on{" "}
        <a href="" onClick={(e) => handleLinkClick(e, "startDate")}>
          {startDateFormatted}
        </a>
        .
      </div>
    );
  }

  function getFirstMonthDiscounted(data: any): number {
    // Tìm đối tượng có giai đoạn chứa tháng đầu tiên (from = 1)
    const firstPeriod = data.find((item: any) => item.from === 1);

    if (!firstPeriod) {
      console.error("Không tìm thấy giai đoạn nào bắt đầu từ tháng đầu tiên.");
      return -1;
    }

    // Tổng số tiền cần trả trong giai đoạn
    const { totalPayable, totalBaseAmount, from, to } = firstPeriod;

    // Tính số tiền cần trả cho tháng đầu tiên
    // return totalPayable / totalMonths;
    return totalPayable;
  }

  function StickyHeader() {
    let cover = getData("customCover") ?? null;
    let priceNow = getData("customCover.premiums.totalPayable") ?? 0;
    let wasPrice = getData("customCover.premiums.totalPayableBeforeDiscount") ?? 0;
    let petName = getData("name") ?? 0;
    let hasCoupon = cover && cover.promo;
    let sumFirstMonthPrice = 0;
    if (cover && ["2", "type2"].includes(cover.promo?.promoType?.toString().toLowerCase())) {
      sumFirstMonthPrice = getFirstMonthDiscounted(
        cover.promo?.policyPremiumInstallmentPayments ?? []
      );
    } else {
      sumFirstMonthPrice = (cover?.premiums?.totalPayable ?? 0) / 12;
    }

    let currentPaymentFrequency = getData("root.selectedPaymentFrequency") ?? "monthly";

    function getWasPrice() {
      if (hasCoupon && wasPrice != priceNow && !isMultiPetPromoCode) {
        return (
          <span className="was-price">
            {formatString(
              calculatePriceFromPaymentFrequency(currentPaymentFrequency, wasPrice, wasPrice / 12),
              StringFormats.Currency
            )}
          </span>
        );
      } else {
        return <></>;
      }
    }
    const formattedPrice: string = formatString(
      calculatePriceFromPaymentFrequency(
        currentPaymentFrequency,
        isMultiPetPromoCode ? wasPrice : priceNow,
        isMultiPetPromoCode ? wasPrice / 12 : sumFirstMonthPrice
      ),
      StringFormats.Currency
    );
    const formattedPaymentFrequency: string = getPaymentFrequencyLabel(currentPaymentFrequency);
    const tip = props.stickyTipName ? _.get(tips, props.stickyTipName) : undefined;

    function handleSaveClick(e: any) {
      e.preventDefault();
      alert("Save clicked");
    }

    return (
      <AnimatePresence>
        {
          <motion.div
            key="sticky-price"
            className={"sticky-header " + (showPriceSticky ? " show" : "")}
          >
            <div className="content">
              <div className="price-info">
                {!loadingPrice && priceNow > 0 && (
                  <>
                    <div className="price">
                      {petName}'s Price:{getWasPrice()} {formattedPrice}
                    </div>{" "}
                    <div className="price-frequency">per {formattedPaymentFrequency}</div>
                  </>
                )}
                {priceNow === 0 && "*.**"}
                {loadingPrice && <Loader className="loader" />}
              </div>
              <div className="quote-info">
                {/* <div className="sticky-quote-number">
                  {qouteNumber}
                </div> */}
                <PetsyQuoteNumber
                  showSaveMyQuote={true}
                  showDivWithIcon={false}
                  showQuoteBox={false}
                  textLabel={"Save My Quote"}
                />
              </div>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    );
  }

  function OnCloseHighestLevelCallback() {
    setIsShowHighestLevelPopup(false);
  }

  return (
    <div data-testid="SelectedCover" className="flc_selected-cover" ref={myRef}>
      {getData("coverType") === "custom" && (
        <LoadingLightbox show={loadingPrice} title="Loading your Quote..." />
      )}
      <StickyHeader />
      {/* {<PetsyCanvasConfetti run={countRunEffect} />} */}
      <PetsyHighestLevelPopup
        show={isShowHighestLevelPopup}
        onClose={OnCloseHighestLevelCallback}
      />
      <div className="content-container">
        <div
          className="title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        ></div>
        <ReactSVGWrapper
          className="image"
          src={petType === "dog" ? props.imageUrlDog : props.imageUrlCat}
        />
        {/* <QuoteNumber /> */}
        <PetDescription />
        <p className="mt-2">{description}</p>
      </div>

      <ErrorModal show={showErrorModal} />
    </div>
  );
}
